/** 冒险岛韩服（账号 game 字段） */
export const GAME_KOREA = '冒险岛韩服'

export function getStoredUserGame() {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}').game || ''
  } catch {
    return ''
  }
}

export function isKoreaGameUser() {
  return getStoredUserGame() === GAME_KOREA
}
